module.exports = {
    backendUrl: "https://dev.vmedicalls.venturing.com.ar/vMedicalls/api",
    oratorEmails: [
        "rodrigo+orador@venturing.com.ar",
    ],

};
